'use strict';

var variables = require('./variables-1eb6495a.js');

const light = {
    root: {
        backgroundColor: variables.COLORS.GREYSCALE_98,
        "&:before": {
            backgroundColor: "unset",
        },
        "&$expanded": {
            margin: "0px",
        },
    },
};

var MuiAccordion = /*#__PURE__*/Object.freeze({
  __proto__: null,
  light: light
});

exports.MuiAccordion = MuiAccordion;
exports.light = light;
